import React, { useState, useEffect} from "react";
import {
  CalendarNextArrow,
  CalendarPrevArrow,
  //   ResetIcon,
  closeIcon
} from "../../../utils/icons";
import PropTypes from "prop-types";
import {
  DateRangePickerContainer,
  HeaderContainer,
  StyledBody,
} from "../../Manager/Dashboard/style";
import { Modal } from "react-bootstrap";
import { RadioButton, RadioButtonWrapper } from "../../RecogntionAdmin/styles";
import {
  Container,
  CalendarHeader,
  Grid,
  Day,
  Button,
  BottomButtons,
  //   ResetButton,
  DownloadButton,
  DayWrap,
  StyledModal
} from './style';
import dayjs from "dayjs";
import { CommonButtonBorder } from "../commonStyles";
import { ManagerIconContainer } from "../../Manager/styles";
import moment from "moment";

const getDaysInMonth = (year, month) => {
  const date = dayjs(new Date(year, month, 1));
  const days = [];
  let current = date;
  while (current.month() === month) {
    days.push(current);
    current = current.add(1, 'day');
  }
  return days;
};

const generateTimeSlots = (startTime, endTime) => {
  const format = "hh:mm A";
  const today = dayjs().format("YYYY-MM-DD"); // Use today's date

  const start = dayjs(`${today} ${startTime}`, "YYYY-MM-DD hh:mm A");
  const end = dayjs(`${today} ${endTime}`, "YYYY-MM-DD hh:mm A");

  const slots = [];
  let current = start;

  while (current <= end) {
    slots.push(current.format(format));
    current = current.add(15, "minute");
  }

  return slots;
};

const updateDateWithTime = (baseDate, selectedTime) => {
  const [timeString, meridian] = selectedTime.split(" "); // e.g., "01:15", "PM"
  const [hourStr, minuteStr] = timeString.split(":");
  
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  // Convert to 24-hour format
  if (meridian === "PM" && hour !== 12) {
    hour += 12;
  } else if (meridian === "AM" && hour === 12) {
    hour = 0;
  }

  // Apply time to baseDate
  const updated = dayjs(baseDate)
    .hour(hour)
    .minute(minute)
    .second(0)
    .millisecond(0);

  return updated;
};



const CustomDateTimePicker = ({ showModal, onClose, date, stateDateSelected, changeDate, type }) => {
  const today = dayjs().startOf('day');
  const [currentMonth, setCurrentMonth] = useState(today.month());
  const [currentYear, setCurrentYear] = useState(today.year());
  const [startDate, setStartDate] = useState(date);
  const days = getDaysInMonth(currentYear, currentMonth);
  const [selectedTimePeriod, setSelectedTimePeriod] = useState("Afternoon");
  const [selectedSlot, setSelectedSlot] = useState(""); 

  const timeSlots = {
    Morning: generateTimeSlots("12:00 AM", "11:45 AM"),
    Afternoon: generateTimeSlots("12:00 PM", "05:45 PM"),
    Evening: generateTimeSlots("06:00 PM", "11:45 PM"),
  };

  useEffect(() => {
    const referenceDate = date;
  
    if (referenceDate) {
      setCurrentMonth(dayjs(referenceDate).month());
      setCurrentYear(dayjs(referenceDate).year());
      setStartDate(referenceDate);
    } else {
      return;
    }
  
    if (showModal && referenceDate && !selectedSlot) {
      const fullTimeObj = dayjs(referenceDate);
  
      // Define exact time ranges
      const timeRanges = {
        Morning: {
          start: dayjs(referenceDate).hour(0).minute(0), // 12:00 AM
          end: dayjs(referenceDate).hour(11).minute(45), // 11:45 AM
        },
        Afternoon: {
          start: dayjs(referenceDate).hour(12).minute(0), // 12:00 PM
          end: dayjs(referenceDate).hour(17).minute(45),  // 5:45 PM
        },
        Evening: {
          start: dayjs(referenceDate).hour(18).minute(0), // 6:00 PM
          end: dayjs(referenceDate).hour(23).minute(45),  // 11:45 PM
        },
      };
  
      let period = "";
  
      if (fullTimeObj.isBetween(timeRanges.Morning.start, timeRanges.Morning.end, null, '[]')) {
        period = "Morning";
      } else if (fullTimeObj.isBetween(timeRanges.Afternoon.start, timeRanges.Afternoon.end, null, '[]')) {
        period = "Afternoon";
      } else if (fullTimeObj.isBetween(timeRanges.Evening.start, timeRanges.Evening.end, null, '[]')) {
        period = "Evening";
      }
  
      if (!period) {
        // Not within any period, do not select anything
        setSelectedTimePeriod("");
        setSelectedSlot("");
        return;
      }
  
      const fullTime = fullTimeObj.format("hh:mm A");
      const slotMatch = timeSlots[period].find((slot) => slot === fullTime);
  
      if (slotMatch) {
        setSelectedTimePeriod(period);
        setSelectedSlot(slotMatch);
      } else {
        setSelectedTimePeriod(period);
        const defaultSlot = timeSlots[period][0];
        setSelectedSlot(defaultSlot);
        const updated = updateDateWithTime(referenceDate, defaultSlot);
        setStartDate(updated);
      }
    }
  }, [date, showModal]);
  

  // useEffect(() => {
  //   const referenceDate = date || stateDateSelected || today;
  //   setCurrentMonth(dayjs(referenceDate).month());
  //   setCurrentYear(dayjs(referenceDate).year());
  // }, [date, showModal]);


  
  
  
  
  const handleMonthChange = (direction) => {
    const newDate = dayjs(new Date(currentYear, currentMonth)).add(direction, 'month');
    const isBeforeToday = newDate.isBefore(today, 'month');
    if (isBeforeToday) return;
    setCurrentMonth(newDate.month());
    setCurrentYear(newDate.year());
  };

  const submitDate = () => {
    changeDate(startDate,type)
  }

  const handleDayClick = (day) => {
    const baseDate =
      type !== "date"
        ? stateDateSelected
          ? dayjs(stateDateSelected).startOf('day')
          : today
        : today;
  
    if (day.isBefore(baseDate, 'day')) return;
  
    const isNewDateToday = day.isSame(dayjs(), "day");
  
    // If selected slot is past in today's date, reset it
    if (isNewDateToday && selectedSlot) {
      const updatedSlotDate = updateDateWithTime(day, selectedSlot);
      if (updatedSlotDate.isBefore(dayjs())) {
        setSelectedSlot(""); // clear selected slot
      }
    }
  
    setStartDate(day);
  };
  
  //   const resetDates = () => {
  //     setStartDate(null);
  //   };

  const isSameDay = (d1, d2) => d1 && d2 && d1.isSame(d2, 'day');
  return (
    <StyledModal
      id="download-popup"
      show={showModal}
      onHide={onClose}
      width={"1072px"}
      right="15%"
    >
      <Modal.Header style={{ background: "#F8F8F8" }}>
        <HeaderContainer id="download-heading">
          <div className="report-title">
            <span className="header-text">Select Date</span>
          </div>
          <ManagerIconContainer style={{ cursor: "pointer", marginBottom: '16px' }} onClick={onClose}>
            {closeIcon("#F37A65", 14, 14)}
          </ManagerIconContainer>
        </HeaderContainer>
      </Modal.Header>
      <StyledBody id="calendar-container" style={{ background: "#F8F8F8", borderRadius:"0 0 6px 6px" }}>
        <DateRangePickerContainer id="date-range-picker">
          <Container id="date-container" className="date-time" isDateTimePicker  isTopPadding={startDate ? "0px 16px 16px 16px" : "16px"}>
            <div id="calendar-container" className="date-container">
              <CalendarHeader id="calendar-header">
                <Button
                  id="prev-button"
                  onClick={() => handleMonthChange(-1)}
                >
                  {CalendarPrevArrow()}
                </Button>
                <span id="month-name" className="title">
                  {dayjs(new Date(currentYear, currentMonth)).format("MMMM YYYY")}
                </span>
                <Button id="next-prev" onClick={() => handleMonthChange(1)}>
                  {CalendarNextArrow()}
                </Button>
              </CalendarHeader>
              <Grid id="grid-days">
                {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((day) => (
                  <div className="day-name" key={day}>{day}</div>
                ))}
              </Grid>
              <DayWrap>
                {
                  // Add empty placeholders before first day
                  Array.from({ length: (days[0].day() + 6) % 7 }).map((_, idx) => (
                    <Day style={{background:"transparent"}} key={`empty-${idx}`} disabled />
                  ))
                }
                {days.map((day) => {
                  const isDisabled =
                    type !== "date"
                      ? stateDateSelected
                        ? day.isBefore(dayjs(stateDateSelected).startOf('day'))
                        : day.isBefore(today)
                      : day.isBefore(today);
                  return (
                    <Day
                      id="days"
                      key={day.toString()}
                      onClick={() => !isDisabled && handleDayClick(day)}
                      isSelected={isSameDay(day, startDate)}
                      disabled={isDisabled}
                    >
                      {day.date()}
                    </Day>
                  );
                })}
              </DayWrap>

            </div>
          

            <div className="time-picker">
              {startDate ? <div className="SelectedDate">{moment(startDate?.$d).format('dddd, MMM D')}</div>:null}

              <RadioButtonWrapper isMargin="12px" width gap>
                {["Morning", "Afternoon", "Evening"].map((period) => (
                  <div
                    key={period}
                    className="RadioButtonContainer"
                    onClick={() => setSelectedTimePeriod(period)}
                    style={{display:"flex", alignItems:"center",width:"30%"}}
                  >
                    <RadioButton
                      id={period}
                      handler={() => setSelectedTimePeriod(period)}
                      type="radio"
                      checked={selectedTimePeriod === period}
                      width={'30%'}
                    />
                    <div className="label" >{period}</div>
                  </div>
                ))}
              </RadioButtonWrapper>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "12px"}}>
                {timeSlots?.[selectedTimePeriod]?.map((time) => {
                  let isPast = false;
                 
                  if (startDate) {
                    const updatedDateTime = updateDateWithTime(dayjs(startDate), time);
                    const isToday = dayjs(startDate).isSame(dayjs(), "day");
                    isPast = isToday && updatedDateTime.isBefore(dayjs());
                  }
                 
                  return (
                    <CommonButtonBorder
                      key={time}
                      onClick={() => {
                        if (!isPast && startDate) {
                          const updated = updateDateWithTime(dayjs(startDate), time);
                          setStartDate(updated);
                          setSelectedSlot(time);
                        }
                      }}
                      disabled={!startDate || isPast}
                      style={{
                        border:
                          selectedSlot === time ? "1px solid #F37A65" : "1px solid #DCDCDC",
                        backgroundColor: !startDate || isPast ? "#f2f2f2" : "#fff",
                        color: !startDate || isPast ? "#999" : "#000",
                        cursor: !startDate || isPast ? "not-allowed" : "pointer",
                        pointerEvents: !startDate || isPast ? "none" : "auto",
                      }}
                    >
                      {time}
                    </CommonButtonBorder>
                  );
                })}

              </div>
            </div>
          </Container>
          <div style={{width:"100%", height:"1px", background:"#EFEFEF", margin:"0 0 16px 0"}}></div>
          <BottomButtons id="bottom-buttons">
            {/* <ResetButton id="reset-dates" onClick={resetDates}>
              <span>{ResetIcon()}</span>
              <span className="reset-text">Reset Dates</span>
            </ResetButton> */}
            <DownloadButton id="download-buttons" disabled={!startDate || !selectedSlot} onClick={()=>submitDate(startDate,type)}>
              Done
            </DownloadButton>
          </BottomButtons>
        </DateRangePickerContainer>
      </StyledBody>
    </StyledModal>
  );
};

CustomDateTimePicker.propTypes = {
  onClose: PropTypes.func,
  showModal: PropTypes.bool,
  date: PropTypes.object,
  stateDateSelected: PropTypes.object,
  type: PropTypes.string,
  changeDate: PropTypes.func,
  resetDatePopup: PropTypes.func
};

export default CustomDateTimePicker;
